import React from "react";
import _ from "lodash"; 
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "@StarberryUtils"
import HTMLReactParser from "html-react-parser";

const PopularSearch = (props) => {
  const data = useStaticQuery(graphql`
    query {
        glstrapi { 
          popularSearch { 
            Popular_Search_Home
            Popular_Search_About
            Popular_Search_Sale
            Popular_Search_Rent
            Popular_Search_Commercial
            Popular_Search_Default
          }
      }
    }
  `);
  const search = data.glstrapi.popularSearch;
  const popularSearch = props?.popular_search ? props.popular_search : 'Popular_Search_Default';
  return (
    <React.Fragment>
      <div className="popular-search">
        
        {search[popularSearch] &&
          HTMLReactParser(search[popularSearch].replace(/<br\s*\/?>/gi, ''))
        }
      </div> 
    </React.Fragment>
  )
}

export default PopularSearch;